/**
 * 工具+数据字典
 */

import api from '@/assets/libs/api.js'
import request from '@/assets/libs/request.js'

/**
 * 获取数据字典
 * 
 * 业务领域,擅长行业,热点行业,常用银行,投资人类型,联系人职位,公司关系,
 * 投资形式,控股要求,企业所处阶段,融资轮次,融资形式,企业资质,当前融资需求用途,融资方式
 * 声明：擅长行业(子节点children)
 * 
 */
export const loadDictData = (names) => {
	return new Promise((resolve, reject) => {
		//const names = '业务领域,擅长行业,热点行业,常用银行,投资人类型,联系人职位,公司关系,投资形式,控股要求,企业所处阶段,融资轮次,融资形式,企业资质,当前融资需求用途,融资方式'
		request.get(api.system.getDictData, {
				dicNames: names
			})
			.then((res) => {
				if (res.code == 200) {
					// setDictData(res.data)
					resolve(res.data)
				} else {
					const error = new Error(res.msg || '数据加载失败')
					reject(error)
				}
			})
			.catch((err) => {
				reject(new Error(err.message || '请求失败'))
			});
	});
}

/**
 * 从数据字典中查找对应的值1
 * dics 数据字典
 * ids 数据字典id 逗号分隔
 * [{"id":29,"dictName":"社会服务”},{"id":30,"dictName":"美容护理”}]
 */
export const getDictNamesByIds = (dics, ids) => {
	ids = ids + ''
	// 检查参数是否有效
	if (!dics || !Array.isArray(dics) || !ids) {
		return '';
	}

	// 分割ids字符串为数字数组
	const idArray = ids.split(',').map(id => Number(id.trim()));

	// 递归查找函数，支持查找嵌套的children结构
	const findDictNameById = (items, targetId) => {
		for (const item of items) {
			// 检查当前项是否匹配
			if (item.id === targetId) {
				return item.dictName || '';
			}

			// 如果有children，递归查找
			if (item.children && Array.isArray(item.children)) {
				const result = findDictNameById(item.children, targetId);
				if (result) {
					return result;
				}
			}
		}
		return ''; // 未找到匹配项
	};

	// 从dics中查找匹配的项目并收集dictName
	const dictNames = [];
	for (const id of idArray) {
		const dictName = findDictNameById(dics, id);
		dictNames.push(dictName);
	}

	// 将dictName数组用逗号连接成字符串返回
	return dictNames.join(', ');
}
/**
 * 从数据字典中查找对应的值2
 * 专家热点行业，带有level等级
 * hotlevels 是字符串如：[{"id":55, "dictName":"Ai产业链”,“level":“大师级”},{"id":56,"dictName":"机器人产业链”,"level":“精英级”}]
 */
export const getDictNamesByHotLevels = (hotlevels) => {
	try {
		// 检查hotlevels是否存在
		if (!hotlevels) {
			return '';
		}
		// 解析JSON字符串
		const parsedData = JSON.parse(hotlevels);
		// 检查解析结果是否为数组
		if (!Array.isArray(parsedData)) {
			return '';
		}

		// 提取dictName并使用' / '连接
		const dictNames = parsedData
			.map(item => item && item.dictName ? item.dictName : '')
			.filter(name => name !== '');

		return dictNames.join(' / ');
	} catch (error) {
		return '';
	}
}

/**
 * 从JSON字符串中提取指定字段的值，并使用指定分隔符连接
 * @param {string} jsonString - JSON字符串，格式如："[{"id":28,"dictName":"商贸零售"},{"id":30,"dictName":"美容护理"}]"
 * @param {string} fieldName - 要提取的字段名，默认为'dictName'
 * @param {string} separator - 连接符，默认为','
 * @returns {string} - 提取的字段值用分隔符连接的结果
 */
export const getDictValuesByField = (jsonString, fieldName = 'dictName', separator = ',') => {
	try {
		// 检查jsonString是否存在
		if (!jsonString) {
			return '';
		}
		// 解析JSON字符串
		const parsedData = JSON.parse(jsonString);
		// 检查解析结果是否为数组
		if (!Array.isArray(parsedData)) {
			return '';
		}

		// 提取指定字段并使用指定分隔符连接
		const fieldValues = parsedData
			.map(item => item && item[fieldName] ? item[fieldName] : '')
			.filter(value => value !== '');

		return fieldValues.join(separator);
	} catch (error) {
		return '';
	}
}

// 节流函数
export const throttle = (fn, delay = 500) => {
	let timer = null
	return function(...args) {
		if (timer) return
		timer = setTimeout(() => {
			fn.apply(this, args)
			timer = null
		}, delay)
	}
}

/**
 * 将中文格式日期转换为标准格式
 * @param {string} chineseDate - 中文日期字符串，格式如：2022年7月15日
 * @returns {string} - 标准日期字符串，格式如：2022-07-15
 */
export const convertChineseDate = (chineseDate) => {
	// 提取年、月、日
	const match = chineseDate.match(/(\d+)年(\d+)月(\d+)日/);
	if (!match) {
		// 如果格式不匹配，返回空
		return '';
	}

	const year = match[1];
	// 使用padStart确保月、日为两位数
	const month = match[2].padStart(2, '0');
	const day = match[3].padStart(2, '0');

	// 组合成yyyy-MM-dd格式
	return `${year}-${month}-${day}`;
}



/**
 * 相对媒体地址转完整访问地址
 * 上传成功后数据库只存相对路径（如 /profile/upload/2026/08/31/xxx.png），
 * 展示时统一拼接 BASE_URL
 * @param {string} url - 相对路径或完整地址
 * @returns {string} - 完整可访问地址
 */
export const resolveMediaUrl = (url) => {
	if (!url) return ''
	if (/^https?:\/\//i.test(url)) return url
	return `${api.base}/${String(url).replace(/^\//, '')}`
}

/**
 * 单文件上传（内部使用）
 * 与 <input type="file"> 配合使用：把 File 对象直接上传到后端
 * @param {File} file - 文件对象
 * @param {Object} parms - 附加的表单参数（可选），会一并放入 FormData
 * @returns {Promise<Object>} - resolve 后端返回的 data（含 url、name、fileName 等）
 */
const uploadOneFile = (file, parms) => {
	return new Promise((resolve, reject) => {
		if (!file) {
			reject(new Error('请选择要上传的文件'))
			return
		}

		// 组装 multipart/form-data
		const formData = new FormData()
		formData.append('file', file, file.name)
		Object.keys(parms || {}).forEach(key => {
			formData.append(key, parms[key])
		})

		// 注入 Authorization（与 request.js 口径一致，但不手动设置 Content-Type，
		// 由浏览器自动生成带 boundary 的 multipart 头）
		const headers = {}
		const token = localStorage.getItem('userToken')
		if (token) {
			headers.Authorization = `Bearer ${token.replace(/^"|"$/g, '')}`
		}

		fetch(api.upload.image, {
				method: 'POST',
				headers,
				body: formData
			})
			.then(res => {
				if (!res.ok) {
					throw new Error(`上传失败 (${res.status})`)
				}
				return res.json()
			})
			.then(data => {
				// 后端约定：code === 200 为成功，data 中含文件地址
				if (data && data.code === 200) {
					resolve(data.data || data)
				} else {
					reject(new Error((data && data.msg) || '上传失败'))
				}
			})
			.catch(err => {
				if (err.message === 'Failed to fetch') {
					reject(new Error('网络请求失败，上传中断'))
				} else {
					reject(err)
				}
			})
	});
}

/**
 * 网页端文件上传（图片/视频/音频等），支持单文件或多文件
 * 与 <input type="file"> 配合使用：
 * - 传入单个 File（如 e.target.files[0]）：行为与之前一致
 * - 传入多个文件（如 e.target.files 或 File 数组）：全部上传成功后，
 *   把各文件地址按顺序用英文逗号拼接（如 url: "/a.png,/b.png"），方便直接存库
 * @param {File|FileList|Array<File>} file - 文件对象、FileList 或文件数组
 * @param {Object} parms - 附加的表单参数（可选），会一并放入 FormData
 * @returns {Promise<Object>} - resolve 后端返回的 data；多文件时字符串字段（url/fileName 等）以英文逗号拼接
 */
export const upload_image = (file, parms = {}) => {
	// 归一化为文件数组（兼容单 File / FileList / 数组）
	let files = []
	if (file) {
		if (Array.isArray(file)) {
			files = file
		} else if (typeof file.length === 'number' && typeof file !== 'string') {
			files = Array.from(file) // FileList
		} else {
			files = [file]
		}
	}

	if (files.length === 0) {
		return Promise.reject(new Error('请选择要上传的文件'))
	}
	// 单文件：与原有行为保持一致
	if (files.length === 1) {
		return uploadOneFile(files[0], parms)
	}

	// 多文件：并行上传，全部成功后把各文件的地址字段以英文逗号拼接
	return Promise.all(files.map(f => uploadOneFile(f, parms))).then(results => {
		const merged = {}
		results.forEach(res => {
			Object.keys(res || {}).forEach(key => {
				if (typeof res[key] === 'string') {
					merged[key] = merged[key] === undefined ? res[key] : `${merged[key]},${res[key]}`
				}
			})
		})
		return merged
	})
}